import {
  ConversationStarter,
  Question,
  Vocabulary,
  LanguageData,
} from '../types/data';

/**
 * Vocabulary
 * 10 most used words per difficulty level
 */
const vocabulary: Vocabulary[] = [
  // Beginner level
  {
    word: 'hola',
    translation: 'hello',
    tags: ['DailyLife'],
    difficulty: 'Beginner',
  },
  {
    word: 'gracias',
    translation: 'thank you',
    tags: ['DailyLife'],
    difficulty: 'Beginner',
  },
  {
    word: 'por favor',
    translation: 'please',
    tags: ['DailyLife'],
    difficulty: 'Beginner',
  },
  {
    word: 'sí',
    translation: 'yes',
    tags: ['DailyLife'],
    difficulty: 'Beginner',
  },
  {
    word: 'no',
    translation: 'no',
    tags: ['DailyLife'],
    difficulty: 'Beginner',
  },
  {
    word: 'agua',
    translation: 'water',
    tags: ['FoodAndDrink', 'DailyLife'],
    difficulty: 'Beginner',
  },
  {
    word: 'comida',
    translation: 'food',
    tags: ['FoodAndDrink'],
    difficulty: 'Beginner',
  },
  {
    word: 'baño',
    translation: 'bathroom',
    tags: ['Travel', 'DailyLife'],
    difficulty: 'Beginner',
  },
  {
    word: 'buenos días',
    translation: 'good morning',
    tags: ['DailyLife'],
    difficulty: 'Beginner',
  },
  {
    word: 'adiós',
    translation: 'goodbye',
    tags: ['DailyLife'],
    difficulty: 'Beginner',
  },

  // Intermediate level
  {
    word: 'quizás',
    translation: 'maybe',
    tags: ['DailyLife'],
    difficulty: 'Intermediate',
  },
  {
    word: 'todavía',
    translation: 'still/yet',
    tags: ['DailyLife'],
    difficulty: 'Intermediate',
  },
  {
    word: 'mientras',
    translation: 'while',
    tags: ['DailyLife'],
    difficulty: 'Intermediate',
  },
  {
    word: 'según',
    translation: 'according to',
    tags: ['Business', 'Education'],
    difficulty: 'Intermediate',
  },
  {
    word: 'aunque',
    translation: 'although',
    tags: ['DailyLife', 'Education'],
    difficulty: 'Intermediate',
  },
  {
    word: 'conseguir',
    translation: 'to get/obtain',
    tags: ['DailyLife', 'Business'],
    difficulty: 'Intermediate',
  },
  {
    word: 'desarrollar',
    translation: 'to develop',
    tags: ['Business', 'Technology'],
    difficulty: 'Intermediate',
  },
  {
    word: 'sin embargo',
    translation: 'however',
    tags: ['Education', 'Business'],
    difficulty: 'Intermediate',
  },
  {
    word: 'además',
    translation: 'furthermore',
    tags: ['Education', 'Business'],
    difficulty: 'Intermediate',
  },
  {
    word: 'establecer',
    translation: 'to establish',
    tags: ['Business', 'Education'],
    difficulty: 'Intermediate',
  },

  // Advanced level
  {
    word: 'imprescindible',
    translation: 'essential',
    tags: ['Business', 'Education'],
    difficulty: 'Advanced',
  },
  {
    word: 'desafortunadamente',
    translation: 'unfortunately',
    tags: ['DailyLife', 'Business'],
    difficulty: 'Advanced',
  },
  {
    word: 'simultáneamente',
    translation: 'simultaneously',
    tags: ['Education', 'Technology'],
    difficulty: 'Advanced',
  },
  {
    word: 'indudablemente',
    translation: 'undoubtedly',
    tags: ['Education', 'Business'],
    difficulty: 'Advanced',
  },
  {
    word: 'prescindible',
    translation: 'dispensable',
    tags: ['Business', 'Education'],
    difficulty: 'Advanced',
  },
  {
    word: 'reivindicar',
    translation: 'to claim/demand',
    tags: ['Business', 'CurrentEvents'],
    difficulty: 'Advanced',
  },
  {
    word: 'menospreciar',
    translation: 'to underestimate/belittle',
    tags: ['DailyLife', 'Education'],
    difficulty: 'Advanced',
  },
  {
    word: 'pormenorizar',
    translation: 'to detail',
    tags: ['Business', 'Education'],
    difficulty: 'Advanced',
  },
  {
    word: 'ensimismado',
    translation: 'absorbed in thought',
    tags: ['Literature', 'Arts'],
    difficulty: 'Advanced',
  },
  {
    word: 'idiosincrasia',
    translation: 'idiosyncrasy',
    tags: ['Culture', 'Education'],
    difficulty: 'Advanced',
  },
];

/**
 * Suggested Questions
 * 10 most used questions per difficulty level
 */
const suggestedQuestions: Question[] = [
  // Beginner level
  {
    question: '¿Cómo te llamas?',
    difficulty: 'Beginner',
    tags: ['DailyLife'],
  },
  {
    question: '¿De dónde eres?',
    difficulty: 'Beginner',
    tags: ['DailyLife', 'Travel'],
  },
  {
    question: '¿Qué hora es?',
    difficulty: 'Beginner',
    tags: ['DailyLife'],
  },
  {
    question: '¿Dónde está el baño?',
    difficulty: 'Beginner',
    tags: ['Travel', 'DailyLife'],
  },
  {
    question: '¿Cuánto cuesta esto?',
    difficulty: 'Beginner',
    tags: ['Travel', 'FoodAndDrink', 'DailyLife'],
  },
  {
    question: '¿Hablas inglés?',
    difficulty: 'Beginner',
    tags: ['Travel', 'DailyLife'],
  },
  {
    question: '¿Cómo estás?',
    difficulty: 'Beginner',
    tags: ['DailyLife'],
  },
  {
    question: '¿Qué es esto?',
    difficulty: 'Beginner',
    tags: ['DailyLife'],
  },
  {
    question: '¿Tienes agua?',
    difficulty: 'Beginner',
    tags: ['FoodAndDrink', 'DailyLife'],
  },
  {
    question: '¿Dónde está el hotel?',
    difficulty: 'Beginner',
    tags: ['Travel'],
  },

  // Intermediate level
  {
    question: '¿Qué te gusta hacer en tu tiempo libre?',
    difficulty: 'Intermediate',
    tags: ['DailyLife', 'Hobbies'],
  },
  {
    question: '¿Cuál es tu película favorita y por qué?',
    difficulty: 'Intermediate',
    tags: ['Entertainment', 'DailyLife'],
  },
  {
    question: '¿Cómo llegas normalmente al trabajo?',
    difficulty: 'Intermediate',
    tags: ['DailyLife', 'Travel'],
  },
  {
    question: '¿Qué tipo de música prefieres escuchar?',
    difficulty: 'Intermediate',
    tags: ['Music', 'Entertainment'],
  },
  {
    question: '¿Podrías recomendarme un buen restaurante cerca de aquí?',
    difficulty: 'Intermediate',
    tags: ['FoodAndDrink', 'Travel'],
  },
  {
    question: '¿Qué opinas sobre la situación política actual?',
    difficulty: 'Intermediate',
    tags: ['CurrentEvents', 'Culture'],
  },
  {
    question: '¿Cómo ha cambiado tu ciudad en los últimos años?',
    difficulty: 'Intermediate',
    tags: ['Culture', 'DailyLife'],
  },
  {
    question: '¿Qué harías si ganaras la lotería?',
    difficulty: 'Intermediate',
    tags: ['DailyLife'],
  },
  {
    question: '¿Has viajado a algún lugar interesante recientemente?',
    difficulty: 'Intermediate',
    tags: ['Travel', 'DailyLife'],
  },
  {
    question: '¿Cuáles son tus metas para el próximo año?',
    difficulty: 'Intermediate',
    tags: ['DailyLife', 'Business'],
  },

  // Advanced level
  {
    question:
      '¿Cómo crees que la inteligencia artificial transformará nuestra sociedad en las próximas décadas?',
    difficulty: 'Advanced',
    tags: ['Technology', 'CurrentEvents', 'Science'],
  },
  {
    question:
      '¿Qué medidas consideras más efectivas para combatir el cambio climático a nivel individual y gubernamental?',
    difficulty: 'Advanced',
    tags: ['CurrentEvents', 'Science', 'Education'],
  },
  {
    question:
      '¿De qué manera la globalización ha afectado a las identidades culturales en tu país?',
    difficulty: 'Advanced',
    tags: ['Culture', 'CurrentEvents', 'Business'],
  },
  {
    question:
      '¿Cuál es tu postura respecto al equilibrio entre la privacidad personal y la seguridad nacional en la era digital?',
    difficulty: 'Advanced',
    tags: ['Technology', 'CurrentEvents'],
  },
  {
    question:
      '¿Cómo ha evolucionado tu perspectiva sobre la educación a lo largo de tu vida?',
    difficulty: 'Advanced',
    tags: ['Education', 'DailyLife'],
  },
  {
    question:
      '¿Qué papel debería jugar el arte en una sociedad cada vez más orientada hacia la tecnología?',
    difficulty: 'Advanced',
    tags: ['Arts', 'Technology', 'Culture'],
  },
  {
    question:
      '¿Hasta qué punto consideras que los medios de comunicación influyen en la formación de la opinión pública?',
    difficulty: 'Advanced',
    tags: ['CurrentEvents', 'Technology'],
  },
  {
    question:
      '¿Cómo afrontarías un dilema ético en el que tus valores personales entran en conflicto con tus responsabilidades profesionales?',
    difficulty: 'Advanced',
    tags: ['Business', 'Education'],
  },
  {
    question:
      '¿De qué manera crees que la literatura refleja y a la vez moldea los valores de una sociedad?',
    difficulty: 'Advanced',
    tags: ['Literature', 'Culture', 'Education'],
  },
  {
    question:
      '¿Cuáles son los desafíos más significativos que enfrentan las democracias contemporáneas?',
    difficulty: 'Advanced',
    tags: ['CurrentEvents', 'Education'],
  },
];

/**
 * Conversation Starters
 * 10 most used conversation starters per difficulty level
 */
const conversationStarters: ConversationStarter[] = [
  // Beginner level
  {
    sentence: 'Me gusta mucho la comida española.',
    translation: 'I really like Spanish food.',
    difficulty: 'Beginner',
    tags: ['FoodAndDrink', 'Culture'],
  },
  {
    sentence: 'Hoy hace muy buen tiempo.',
    translation: 'The weather is very nice today.',
    difficulty: 'Beginner',
    tags: ['DailyLife'],
  },
  {
    sentence: 'Mi familia es de Madrid.',
    translation: 'My family is from Madrid.',
    difficulty: 'Beginner',
    tags: ['DailyLife', 'Travel'],
  },
  {
    sentence: 'Me encanta viajar por España.',
    translation: 'I love traveling around Spain.',
    difficulty: 'Beginner',
    tags: ['Travel', 'DailyLife'],
  },
  {
    sentence: 'Estoy aprendiendo español.',
    translation: 'I am learning Spanish.',
    difficulty: 'Beginner',
    tags: ['Education', 'DailyLife'],
  },
  {
    sentence: 'Me gustaría practicar mi español.',
    translation: 'I would like to practice my Spanish.',
    difficulty: 'Beginner',
    tags: ['Education', 'DailyLife'],
  },
  {
    sentence: 'Vivo en una ciudad pequeña.',
    translation: 'I live in a small city.',
    difficulty: 'Beginner',
    tags: ['DailyLife'],
  },
  {
    sentence: 'Me gusta escuchar música española.',
    translation: 'I like listening to Spanish music.',
    difficulty: 'Beginner',
    tags: ['Music', 'Culture'],
  },
  {
    sentence: 'Trabajo como profesor.',
    translation: 'I work as a teacher.',
    difficulty: 'Beginner',
    tags: ['DailyLife', 'Education'],
  },
  {
    sentence: 'Mi deporte favorito es el fútbol.',
    translation: 'My favorite sport is soccer.',
    difficulty: 'Beginner',
    tags: ['Sports', 'DailyLife'],
  },

  // Intermediate level
  {
    sentence:
      'Últimamente he estado pensando en mudarme a un país de habla hispana para mejorar mi español.',
    translation:
      'Lately I have been thinking about moving to a Spanish-speaking country to improve my Spanish.',
    difficulty: 'Intermediate',
    tags: ['Travel', 'Education', 'DailyLife'],
  },
  {
    sentence:
      'La gastronomía española es muy diversa, cada región tiene sus platos típicos.',
    translation:
      'Spanish gastronomy is very diverse, each region has its typical dishes.',
    difficulty: 'Intermediate',
    tags: ['FoodAndDrink', 'Culture', 'Travel'],
  },
  {
    sentence:
      'Me encantaría conocer más sobre la historia y la cultura de los países latinoamericanos.',
    translation:
      'I would love to learn more about the history and culture of Latin American countries.',
    difficulty: 'Intermediate',
    tags: ['Culture', 'Education', 'Travel'],
  },
  {
    sentence:
      'Creo que el cine español tiene directores muy talentosos como Pedro Almodóvar y Alejandro Amenábar.',
    translation:
      'I think Spanish cinema has very talented directors like Pedro Almodóvar and Alejandro Amenábar.',
    difficulty: 'Intermediate',
    tags: ['Entertainment', 'Culture', 'Arts'],
  },
  {
    sentence:
      'He notado que hay muchas diferencias entre el español de España y el de Latinoamérica.',
    translation:
      'I have noticed that there are many differences between the Spanish from Spain and that of Latin America.',
    difficulty: 'Intermediate',
    tags: ['Culture', 'Education'],
  },
  {
    sentence:
      'Estoy leyendo una novela de Gabriel García Márquez para mejorar mi vocabulario.',
    translation:
      'I am reading a novel by Gabriel García Márquez to improve my vocabulary.',
    difficulty: 'Intermediate',
    tags: ['Literature', 'Education'],
  },
  {
    sentence:
      'Me gustaría visitar el Museo del Prado la próxima vez que vaya a Madrid.',
    translation:
      'I would like to visit the Prado Museum the next time I go to Madrid.',
    difficulty: 'Intermediate',
    tags: ['Travel', 'Arts', 'Culture'],
  },
  {
    sentence:
      'En mi opinión, aprender idiomas es una de las mejores formas de entender diferentes culturas.',
    translation:
      'In my opinion, learning languages is one of the best ways to understand different cultures.',
    difficulty: 'Intermediate',
    tags: ['Education', 'Culture'],
  },
  {
    sentence:
      'Siempre he querido asistir a las fiestas de San Fermín en Pamplona.',
    translation:
      'I have always wanted to attend the San Fermín festival in Pamplona.',
    difficulty: 'Intermediate',
    tags: ['Travel', 'Culture', 'Entertainment'],
  },
  {
    sentence:
      'La música latina está ganando cada vez más popularidad en todo el mundo.',
    translation: 'Latin music is gaining more and more popularity worldwide.',
    difficulty: 'Intermediate',
    tags: ['Music', 'Culture', 'Entertainment'],
  },

  // Advanced level
  {
    sentence:
      'La diversidad lingüística en España, con idiomas como el catalán, el gallego y el euskera, refleja la riqueza cultural del país y plantea interesantes debates sobre identidad nacional.',
    translation:
      'The linguistic diversity in Spain, with languages such as Catalan, Galician, and Basque, reflects the cultural richness of the country and raises interesting debates about national identity.',
    difficulty: 'Advanced',
    tags: ['Culture', 'Education', 'CurrentEvents'],
  },
  {
    sentence:
      'El realismo mágico, popularizado por autores latinoamericanos como Gabriel García Márquez y Isabel Allende, ha tenido una influencia significativa en la literatura mundial contemporánea.',
    translation:
      'Magical realism, popularized by Latin American authors such as Gabriel García Márquez and Isabel Allende, has had a significant influence on contemporary world literature.',
    difficulty: 'Advanced',
    tags: ['Literature', 'Arts', 'Culture'],
  },
  {
    sentence:
      'La transición española de la dictadura a la democracia es considerada un modelo ejemplar, aunque no exento de controversias y asuntos pendientes de resolución.',
    translation:
      'The Spanish transition from dictatorship to democracy is considered an exemplary model, although not without controversies and pending issues to be resolved.',
    difficulty: 'Advanced',
    tags: ['CurrentEvents', 'Education', 'Culture'],
  },
  {
    sentence:
      'El fenómeno de la despoblación rural, conocido como "la España vacía", representa uno de los mayores desafíos demográficos y económicos para el país en las próximas décadas.',
    translation:
      'The phenomenon of rural depopulation, known as "empty Spain", represents one of the greatest demographic and economic challenges for the country in the coming decades.',
    difficulty: 'Advanced',
    tags: ['CurrentEvents', 'Culture', 'Business'],
  },
  {
    sentence:
      'La influencia del español en Estados Unidos continúa creciendo, no solo demográficamente sino también culturalmente, transformando aspectos fundamentales de la identidad estadounidense.',
    translation:
      'The influence of Spanish in the United States continues to grow, not only demographically but also culturally, transforming fundamental aspects of American identity.',
    difficulty: 'Advanced',
    tags: ['Culture', 'CurrentEvents', 'Education'],
  },
  {
    sentence:
      'El legado arquitectónico islámico en España, ejemplificado por monumentos como la Alhambra, representa un testimonio excepcional de la convivencia histórica entre diferentes culturas en la península ibérica.',
    translation:
      'The Islamic architectural legacy in Spain, exemplified by monuments such as the Alhambra, represents an exceptional testimony to the historical coexistence between different cultures in the Iberian Peninsula.',
    difficulty: 'Advanced',
    tags: ['Culture', 'Arts', 'Education'],
  },
  {
    sentence:
      'La crisis económica de 2008 provocó un replanteamiento profundo de los modelos de desarrollo en España y Latinoamérica, con consecuencias políticas y sociales que perduran hasta hoy.',
    translation:
      'The 2008 economic crisis caused a profound rethinking of development models in Spain and Latin America, with political and social consequences that persist to this day.',
    difficulty: 'Advanced',
    tags: ['Business', 'CurrentEvents', 'Education'],
  },
  {
    sentence:
      'El auge de las energías renovables en países como Chile y España está transformando el panorama energético global y ofreciendo soluciones innovadoras frente al cambio climático.',
    translation:
      'The rise of renewable energies in countries such as Chile and Spain is transforming the global energy landscape and offering innovative solutions to climate change.',
    difficulty: 'Advanced',
    tags: ['Technology', 'Science', 'CurrentEvents'],
  },
  {
    sentence:
      'La gastronomía molecular española, liderada por chefs como Ferran Adrià, ha revolucionado la cocina contemporánea mediante la aplicación de principios científicos a técnicas culinarias tradicionales.',
    translation:
      'Spanish molecular gastronomy, led by chefs such as Ferran Adrià, has revolutionized contemporary cuisine by applying scientific principles to traditional culinary techniques.',
    difficulty: 'Advanced',
    tags: ['FoodAndDrink', 'Science', 'Culture'],
  },
  {
    sentence:
      'El concepto de "memoria histórica" en España ha generado intensos debates sobre cómo las sociedades democráticas deben abordar y reconciliarse con pasados traumáticos.',
    translation:
      'The concept of "historical memory" in Spain has generated intense debates about how democratic societies should address and reconcile with traumatic pasts.',
    difficulty: 'Advanced',
    tags: ['CurrentEvents', 'Culture', 'Education'],
  },
];

export const spanish: LanguageData = {
  vocabulary,
  suggestedQuestions,
  conversationStarters,
};
